<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';

import useContext from '@/composables/useContext';

import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import Search from '@/components/search/Search.vue';
import { setCookieInformationScript } from '../functions/cookie.functions';
import GiftCardRedirectNotice from "@/components/GiftCardRedirectNotice.vue";
import Snackbar from "@/components/Snackbar.vue";
import ScrollToTopButton from '@/components/ScrollToTopButton.vue';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { useRouteScrollReset } from '@/composables/useRouteScrollReset';

const isMounted = ref(false);
const showNotice = ref(false);
const showLoginSnackbar = ref(false);
const { channel } = useContext();
const { websiteText } = useWebsiteTexts();

useRouteScrollReset();

watch(channel, (newVal, _) => {
  if (newVal != undefined) {
    setCookieInformationScript(newVal.language);
  }
});

onMounted(async () => {
  isMounted.value = true;
  if (localStorage.getItem("ShowLoginNotification")) {
    showLoginSnackbar.value = true;
    localStorage.removeItem("ShowLoginNotification");
  }
  if (document.cookie.includes("GiftCardRedirected=1")) {
    showNotice.value = true;
    document.cookie = "GiftCardRedirected=; Max-Age=0; path=/;";
  }
});

const disableShowNotice = () => {
  showNotice.value = false;
  if (document.cookie.includes("GiftCardRedirected=1")) {
    document.cookie = "GiftCardRedirected=; Max-Age=0; path=/;";
  }
};

</script>

<template>
  <div class="app-shell">
    <GiftCardRedirectNotice v-if="showNotice" :disableShowNotice="disableShowNotice"
      :message="websiteText('giftcard__notice').value" />
    <SiteHeader />
    <Search v-if="isMounted" />
    <main class="app-shell__main">
      <router-page />
    </main>
    <SiteFooter />
    <Snackbar
      v-if="showLoginSnackbar"
      :message="websiteText('login__welcome_notice').value"
      @dismiss="showLoginSnackbar = false"
    />
    <ScrollToTopButton />
  </div>
</template>

<style scoped>
.app-shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-shell__main {
  flex: 1 0 auto;
}
</style>
